import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadAllProgram, UpdateProgram } from '../../../actions/Activites/Programmes';
import ModalAddProgram from '../../../modal/admin/actvites/ModalAddProgram';
import { baseUrl } from '../../../nametitle/dataUrl';
import LoaderBootStrap from '../dasboard/LoaderBootStrap';

const ListProgramAdmin = () => {

  const navigate = useNavigate("");
  const [idProgram, setidProgram] = useState("")
  const [title, settitle] = useState("")
  const [coverPicture, setcoverPicture] = useState("");
  const [description, setdescription] = useState("");
  const [visible, setvisible] = useState("");

  const [Loading, setLoading] = useState();
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
      fileReader.onerror = (error) => { reject(error); };
    });
  }
  function uploadSingleImage(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChange = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleImage(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };


  const [ProgramList, setProgramList] = useState([])
  useEffect(() => {
    LoadAllProgram(setProgramList);
  }, [])
  return (
    <div>
      <div className="w-full container-fluid py-5">

        <div className="w-full flex space-x-3 justify-between mb-5">
          <div className="input-group">
            <input type="text" className="form-control p-1 translatable" placeholder="rechercher programme ..." />
            <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
          </div>
          {/* Ajouter button */}
          <button className="btn btn-primary px-4 translatable" data-bs-toggle="modal" data-bs-target="#addModal" >Ajouter</button>
        </div>
        {/* Modal Add Event */}
        <ModalAddProgram />

        <div className="w-full ">
          {/* <button type="button" className="btn btn-outline-primary py-1 px-2" data-bs-toggle="modal" data-bs-target="#updateModal">modifier</button> */}

          <div className="w-full blog-item mb-5">
            {
              ProgramList && ProgramList.length > 0 ?
                (
                  ProgramList.map((item) => {
                    return (
                      <div className=" w-full border lg:max-w-full ">
                        {/* <div className="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none */}
                        
                        <div className="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                        
                          <div className="mb-8">
                          <img className="h-[100px] w-[100px] " src={item.coverPicture}/>
                            <p className="text-sm text-gray-600 flex items-center">
                              <svg className="fill-current text-gray-500 w-3 h-3 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M4 8V6a6 6 0 1 1 12 0v2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h1zm5 6.73V17h2v-2.27a2 2 0 1 0-2 0zM7 6v2h6V6a3 3 0 0 0-6 0z" />
                              </svg>
                              programme
                            </p>
                            <div className="text-gray-900 font-bold text-xl mb-2 translatable">{item.title}</div>
                            <p className="text-gray-700 text-base line-clamp-4 translatable">{item.description}</p>
                          </div>
                          <div className="flex items-center">
                            <div className="mx-3 flex space-x-3">
                              <button type="button" className="btn btn-outline-success translatable" data-bs-toggle="modal" data-bs-target="#updateModal"
                              onClick={() => {
                                setidProgram(item._id);
                                settitle(item.title);
                                setdescription(item.description);
                                setcoverPicture(item.coverPicture);
                                setvisible(item.visible);
                              }}
                              >modifier</button>
                            </div>
                          </div>
                        </div>
                        {/* Modal Event */}
                        <div className=" modal fade " id="updateModal" tabIndex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div className="modal-dialog">
                            <div className="modal-content rounded-0">
                              <div className="modal-header relative">
                                <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>
                                  Modifier cet programme
                                </h6>
                                <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
                              </div>
                              <div className="modal-body h-[440px] container flex justify-center">
                                <div className="flex justify-center row g-8">
                                  <div className="col-lg-9">
                                    <form onSubmit={(e) => {
                                      e.preventDefault();
                                      UpdateProgram(idProgram, title, coverPicture, description,visible, navigate);
                                    }}>
                                      <div className="row g-3">
                                        <div className="col-12">
                                          <input type="text" onChange={(e) => { settitle(e.target.value) }} value={title} required className="form-control bg-light border-0 px-4 py-1 translatable" placeholder="tittre ..." style={{ height: "40px" }} />
                                        </div>
                                        <div className="col-12 flex">
                                          <input type="file" onChange={HandleFileInputChange} accept=".JPG,.JPEG,.PNG"  className="form-control bg-light border-0 px-4 translatable" placeholder="Votre email" style={{ height: "40px" }} />

                                          <img src={`${coverPicture}`} className="h-[50px] h-[50px]" />

                                        </div>
                                        <div className="col-12">
                                          <textarea onChange={(e) => { setdescription(e.target.value) }} value={description} required className="form-control bg-light border-0 px-4 translatable" placeholder="description ..." style={{ height: "155px" }} />
                                        </div>
                                        <div class='col-12 flex items-center'>
                                      <label
                                        class='form-control border-0 px-2 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        visibilité
                                      </label>
                                      <input
                                        type='checkbox'
                                        class='form-check-input form-control border-0 px-4'
                                        checked={visible}
                                        onChange={e => {
                                          setvisible(e.currentTarget.checked)
                                          console.log(visible)
                                        }}
                                        placeholder='date'
                                        style={{ height: '40px' }}
                                      />
                                    </div>
                                        <div className="col-12">
                                          <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Modifier</button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    )
                  })
                ) :
                <LoaderBootStrap/>
            }
          </div>
        </div>
      </div>
    </div>)
}

export default ListProgramAdmin;